(function () {
  const themeStrings = window.themeStrings || {};

  function getThemeString(path, fallback) {
    const parts = String(path || "").split(".");
    let current = themeStrings;

    for (const part of parts) {
      if (!current || typeof current !== "object" || !(part in current)) {
        return fallback;
      }
      current = current[part];
    }

    return typeof current === "string" ? current : fallback;
  }

  function getShopifyRoutesRoot() {
    const routesRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (typeof routesRoot === "string" && routesRoot) {
      return routesRoot;
    }

    return "/";
  }

  function getLocaleRootPath() {
    const routesRoot = getShopifyRoutesRoot();
    if (routesRoot && routesRoot !== "/") {
      return routesRoot.replace(/\/$/, "");
    }

    const pathname = window.location && window.location.pathname ? window.location.pathname : "/";
    const match = pathname.match(/^\/([a-z]{2})(?:\/|$)/i);
    return match ? "/" + match[1] : "";
  }

  function localizeInternalUrl(path) {
    const value = String(path || "");
    const localeRoot = getLocaleRootPath();
    if (!value || !localeRoot) return value;
    if (value.indexOf("://") !== -1 || value.indexOf("//") === 0 || value.charAt(0) === "#" || value.charAt(0) === "?") {
      return value;
    }
    if (value === localeRoot || value.indexOf(localeRoot + "/") === 0) return value;
    if (value.charAt(0) === "/") return localeRoot + value;
    return value;
  }

  window.themeLocalizeInternalUrl = localizeInternalUrl;

  function getCheckoutUrl() {
    if (window.themeRoutes && window.themeRoutes.checkoutUrl) {
      return window.themeRoutes.checkoutUrl;
    }

    const documentLocale = document.documentElement.getAttribute("lang") || "";
    const localeRoot = getLocaleRootPath();
    if (/^ar\b/i.test(documentLocale) || localeRoot === "/ar") {
      return (localeRoot || "/ar") + "/checkout?locale=ar";
    }

    return localizeInternalUrl("/checkout");
  }

  function submitLocalizedCheckout() {
    window.location.href = getCheckoutUrl();
  }

  window.themeSubmitLocalizedCheckout = submitLocalizedCheckout;

  function initLocalizedCheckoutForms() {
    document.querySelectorAll("[data-localized-checkout-form]").forEach(function (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        submitLocalizedCheckout();
      });
    });
  }

  function fillTemplate(template, replacements) {
    return String(template || "").replace(/__([A-Z_]+)__/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(replacements || {}, key)
        ? replacements[key]
        : match;
    });
  }

  function formatMoney(cents, currency) {
    if (typeof cents !== "number" || Number.isNaN(cents)) return "";
    if (currency === "EGP") {
      return "LE " + (cents / 100).toFixed(2);
    }
    return (cents / 100).toLocaleString(undefined, {
      style: "currency",
      currency: currency || "EGP",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  function getLocaleForDeliveryDates() {
    const rootLocale = document.documentElement.getAttribute("lang") || "";
    if (/^ar\b/i.test(rootLocale)) return "ar-EG";
    return "en-GB";
  }

  function formatDeliveryDateLabel(date, locale) {
    return new Intl.DateTimeFormat(locale, {
      weekday: "short",
      day: "numeric",
      month: "short",
    }).format(date);
  }

  function buildDeliveryNoteText() {
    const now = new Date();
    const startDate = new Date(now);
    const endDate = new Date(now);
    startDate.setDate(startDate.getDate() + 1);
    endDate.setDate(endDate.getDate() + 3);

    const locale = getLocaleForDeliveryDates();
    const startLabel = formatDeliveryDateLabel(startDate, locale);
    const endLabel = formatDeliveryDateLabel(endDate, locale);
    const template = getThemeString("cart.deliveryTemplate", "Delivery __START__ – __END__ (Express)");

    return fillTemplate(template, {
      START: startLabel,
      END: endLabel,
    });
  }

  function toUniqueElements(elements) {
    return Array.from(
      new Set(
        (elements || []).filter(function (element) {
          return element instanceof Element;
        })
      )
    );
  }

  function setElementLoading(element, isLoading) {
    if (!(element instanceof Element)) return;

    if (isLoading) {
      if (element.classList.contains("is-cart-loading")) return;

      element.classList.add("is-cart-loading");
      element.setAttribute("aria-busy", "true");

      if ("disabled" in element) {
        element.dataset.loaderWasDisabled = element.disabled ? "true" : "false";
        element.disabled = true;
      } else {
        element.setAttribute("aria-disabled", "true");
      }

      return;
    }

    element.classList.remove("is-cart-loading");
    element.removeAttribute("aria-busy");

    if ("disabled" in element) {
      if (element.dataset.loaderWasDisabled !== "true") {
        element.disabled = false;
      }
      delete element.dataset.loaderWasDisabled;
    } else {
      element.removeAttribute("aria-disabled");
    }
  }

  function setElementsLoading(elements, isLoading) {
    const uniqueElements = toUniqueElements(elements);
    for (const element of uniqueElements) {
      setElementLoading(element, isLoading);
    }
    return uniqueElements;
  }

  function getSubmissionControls(form, options) {
    const config = options || {};
    const controls = [];

    if (config.submitter instanceof Element) {
      controls.push(config.submitter);
    }

    if (Array.isArray(config.relatedControls)) {
      controls.push.apply(controls, config.relatedControls);
    }

    const pdpMain = form.closest("[data-pdp-main]");
    if (pdpMain) {
      const mainAddButton = pdpMain.querySelector('button[name="add"]');
      const stickyAddButton = document.querySelector("[data-pdp-sticky-add]");

      if (mainAddButton) {
        controls.push(mainAddButton);
      }
      if (stickyAddButton) {
        controls.push(stickyAddButton);
      }
    }

    return toUniqueElements(controls);
  }

  function initHomeHero(heroSection) {
    const slides = Array.from(heroSection.querySelectorAll(".home-hero__slide"));
    const dots = Array.from(heroSection.querySelectorAll(".home-hero__dot"));
    const prev = heroSection.querySelector("[data-hero-prev]");
    const next = heroSection.querySelector("[data-hero-next]");
    if (slides.length < 2) return;

    const parityMode =
      Boolean(window.__PARITY_MODE__) ||
      document.documentElement?.dataset?.parityMode === "1";
    const intervalMs = 6000;
    let index = 0;
    let intervalId = null;

    function show(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;

      for (const slide of slides) {
        slide.classList.remove("is-active");
      }
      for (const dot of dots) {
        dot.classList.remove("is-active");
      }

      slides[index].classList.add("is-active");
      if (dots[index]) {
        dots[index].classList.add("is-active");
      }
    }

    function start() {
      stop();
      intervalId = window.setInterval(function () {
        show(index + 1);
      }, intervalMs);
    }

    function stop() {
      if (intervalId) {
        window.clearInterval(intervalId);
        intervalId = null;
      }
    }

    for (const [dotIndex, dot] of dots.entries()) {
      dot.addEventListener("click", function () {
        show(dotIndex);
        start();
      });
    }

    if (prev) {
      prev.addEventListener("click", function () {
        show(index - 1);
        start();
      });
    }
    if (next) {
      next.addEventListener("click", function () {
        show(index + 1);
        start();
      });
    }

    heroSection.addEventListener("mouseenter", stop);
    heroSection.addEventListener("mouseleave", start);

    show(0);
    if (parityMode) {
      stop();
      return;
    }
    start();
  }

  function initSecondaryAtcScroll() {
    const triggers = document.querySelectorAll("[data-scroll-main-atc]");
    if (!triggers.length) return;

    for (const trigger of triggers) {
      trigger.addEventListener("click", function () {
        const target = document.getElementById("main-atc-btn");
        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    }
  }

  function initCartDrawer() {
    const drawer = document.querySelector("[data-cart-drawer]");
    const backdrop = document.querySelector("[data-cart-drawer-backdrop]");
    const closeBtn = document.querySelector("[data-cart-drawer-close]");
    const itemsWrap = document.querySelector("[data-cart-drawer-items]");
    const subtotalEl = document.querySelector("[data-cart-drawer-subtotal]");
    const countEl = document.querySelector("[data-cart-drawer-count]");
    const shippingBarEl = document.querySelector("[data-cart-shipping-bar]");
    const shippingMsgEl = document.querySelector("[data-cart-shipping-msg]");
    const shippingFillEl = document.querySelector("[data-cart-shipping-fill]");
    const deliveryNoteTextEl = document.querySelector("[data-cart-delivery-note] span");
    const bottomInfoEl = document.querySelector("[data-cart-drawer-bottom]");
    const footerEl = document.querySelector("[data-cart-drawer-footer]");
    const triggers = document.querySelectorAll("[data-cart-trigger]");
    const mockAddButtons = document.querySelectorAll("[data-home-mock-add]");
    const shopCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "EGP";
    const freeShippingThresholdCents = getFreeShippingThresholdCents();
    const mockCart = [];
    const bestSellerHandleCache = new Map();
    let isUpdating = false;

    if (!drawer || !backdrop || !itemsWrap || !subtotalEl) return;
    updateDeliveryNote();

    function getFreeShippingThresholdCents() {
      const barThreshold = Number(shippingBarEl?.dataset.freeShippingThresholdCents || NaN);
      if (Number.isFinite(barThreshold) && barThreshold > 0) return barThreshold;
      return null;
    }

    function updateShippingBar(subtotalCents) {
      if (!shippingBarEl || !shippingMsgEl || !shippingFillEl || freeShippingThresholdCents === null) return;
      const pct = Math.min(100, (subtotalCents / freeShippingThresholdCents) * 100);
      shippingFillEl.style.width = pct + "%";
      if (subtotalCents >= freeShippingThresholdCents) {
        shippingMsgEl.innerHTML =
          '<span class="cart-drawer__shipping-success">🎉 ' +
          escapeHtml(getThemeString("cart.shippingSuccess", "Free shipping now available!")) +
          "</span>";
      } else {
        const remaining = formatMoney(freeShippingThresholdCents - subtotalCents, shopCurrency);
        shippingMsgEl.innerHTML =
          '<span>' +
          escapeHtml(getThemeString("cart.shippingPrefix", "Add")) +
          '</span> <strong class="cart-drawer__shipping-amount">' +
          remaining +
          '</strong> <span>' +
          escapeHtml(getThemeString("cart.shippingSuffix", "more for free shipping!")) +
          "</span>";
      }
    }

    function updateDrawerCount(itemCount) {
      if (countEl) {
        countEl.textContent = fillTemplate(
          getThemeString("cart.totalItemsTemplate", "__COUNT__ item(s)"),
          { COUNT: itemCount }
        );
      }
    }

    function updateDeliveryNote() {
      if (!deliveryNoteTextEl) return;
      deliveryNoteTextEl.textContent = buildDeliveryNoteText();
    }

    function blurActiveSearchInput() {
      const active = document.activeElement;
      if (
        active instanceof HTMLElement &&
        active.matches("[data-header-search-input], [data-mobile-search-input]")
      ) {
        active.blur();
      }
    }

    function setOpen(open) {
      if (open) {
        blurActiveSearchInput();
      }
      drawer.classList.toggle("is-open", open);
      backdrop.classList.toggle("is-open", open);
      document.body.classList.toggle("cart-drawer-open", open);
      drawer.setAttribute("aria-hidden", open ? "false" : "true");
    }

    function updateHeaderCount(count) {
      const countEls = document.querySelectorAll(".header-cart-count, .header-actions__cart-count");
      for (const el of countEls) {
        const displayCount = count > 9 ? "9+" : String(count);
        el.textContent = displayCount;
        if (count > 0) {
          el.classList.remove("is-empty");
        } else {
          el.classList.add("is-empty");
        }
        el.setAttribute("data-cart-count", String(count));
      }
    }

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/\"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    function setBottomSectionsVisibility(hasItems) {
      if (bottomInfoEl) bottomInfoEl.classList.toggle("is-hidden", !hasItems);
      if (footerEl) footerEl.classList.toggle("is-hidden", !hasItems);
    }

    function hasBestSellerKeyword(value) {
      return /best\s*-?\s*seller/i.test(String(value || ""));
    }

    function parseHandleFromItem(item) {
      if (item && item.handle) return String(item.handle);
      const url = item && item.url ? String(item.url) : "";
      const match = url.match(/\/products\/([^/?#]+)/i);
      return match ? decodeURIComponent(match[1]) : "";
    }

    function getItemProperties(item) {
      if (item && item.properties && typeof item.properties === "object") return item.properties;
      return {};
    }

    function isBestSellerByProperties(item) {
      const props = getItemProperties(item);
      const rawFlag = props._is_best_seller;
      if (rawFlag != null) {
        const normalized = String(rawFlag).trim().toLowerCase();
        if (normalized === "1" || normalized === "true" || normalized === "yes") return true;
      }
      const badge = props._badge || props.badge;
      if (badge && hasBestSellerKeyword(badge)) return true;
      return false;
    }

    async function fetchBestSellerByHandle(handle) {
      if (!handle) return false;

      if (!bestSellerHandleCache.has(handle)) {
        const request = fetch(localizeInternalUrl("/products/" + encodeURIComponent(handle) + ".js"), {
          headers: { Accept: "application/json" },
        })
          .then(function (response) {
            if (!response.ok) return null;
            return response.json();
          })
          .then(function (product) {
            if (!product) return false;
            const tags = Array.isArray(product.tags) ? product.tags : [];
            return tags.some(function (tag) {
              return hasBestSellerKeyword(tag);
            });
          })
          .catch(function () {
            return false;
          });

        bestSellerHandleCache.set(handle, request);
      }

      return bestSellerHandleCache.get(handle);
    }

    async function updateUrgencyVisibility(items) {
      const urgencyEl = itemsWrap.querySelector("[data-cart-urgency]");
      if (!urgencyEl) return;

      if (!Array.isArray(items) || items.length === 0) {
        urgencyEl.classList.add("is-hidden");
        return;
      }

      if (items.some(isBestSellerByProperties)) {
        urgencyEl.classList.remove("is-hidden");
        return;
      }

      const handles = Array.from(
        new Set(
          items
            .map(parseHandleFromItem)
            .filter(Boolean)
        )
      );

      if (!handles.length) {
        urgencyEl.classList.add("is-hidden");
        return;
      }

      const results = await Promise.all(
        handles.map(function (handle) {
          return fetchBestSellerByHandle(handle);
        })
      );

      if (!urgencyEl.isConnected) return;
      urgencyEl.classList.toggle("is-hidden", !results.some(Boolean));
    }

    function getLinePrice(item) {
      if (typeof item.final_line_price === "number") return item.final_line_price;
      return (item.price_cents || 0) * (item.quantity || 1);
    }

    function getOriginalLinePrice(item) {
      if (typeof item.original_line_price === "number") return item.original_line_price;
      return getLinePrice(item);
    }

    function normalizeImageUrl(url) {
      if (!url) return "";
      if (typeof url === "string" && url.indexOf("//") === 0) return "https:" + url;
      return String(url);
    }

    function isPlaceholderVariantText(value) {
      return String(value || "").trim().toLowerCase() === "default title";
    }

    function getVariantText(item) {
      if (item.pack && !isPlaceholderVariantText(item.pack)) return String(item.pack);
      const rawVariant = (item.variant_title || "").trim();
      if (rawVariant && !isPlaceholderVariantText(rawVariant)) return rawVariant;
      if (Array.isArray(item.options_with_values) && item.options_with_values.length > 0) {
        return item.options_with_values
          .map(function (option) {
            return option && option.value ? option.value : "";
          })
          .filter(function (value) {
            return value && !isPlaceholderVariantText(value);
          })
          .join(" / ");
      }
      return "";
    }

    function getLineKey(item, index) {
      if (item.key) return String(item.key);
      if (item.mock_key) return String(item.mock_key);
      return "mock::" + index;
    }

    function renderEmptyCart() {
      updateHeaderCount(0);
      updateDrawerCount(0);
      updateShippingBar(0);
      subtotalEl.textContent = formatMoney(0, shopCurrency);
      setBottomSectionsVisibility(false);
      itemsWrap.innerHTML =
        '<div class="cart-drawer__empty-state">' +
          '<svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="#d9dde6" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<circle cx="9" cy="20" r="1"></circle><circle cx="18" cy="20" r="1"></circle><path d="M3 4h2l2.4 11.2a1 1 0 0 0 1 .8h8.9a1 1 0 0 0 1-.8L20 7H7"></path>' +
          "</svg>" +
          '<p class="cart-drawer__empty">' +
          escapeHtml(getThemeString("cart.emptyDetail", "Your cart is empty. Add a product to get started.")) +
          "</p>" +
        "</div>";
    }

    function renderCartItems(items, subtotalCents, itemCount) {
      const safeItems = Array.isArray(items) ? items : [];
      const safeSubtotal = Number.isFinite(subtotalCents) ? subtotalCents : 0;
      const safeItemCount = Number.isFinite(itemCount) ? itemCount : 0;

      updateHeaderCount(safeItemCount);
      updateDrawerCount(safeItemCount);
      updateShippingBar(safeSubtotal);
      subtotalEl.textContent = formatMoney(safeSubtotal, shopCurrency);

      if (!safeItems.length) {
        renderEmptyCart();
        return;
      }

      setBottomSectionsVisibility(true);

      const markup = safeItems
        .map(function (item, index) {
          const props = item.properties || {};

          // Suppress Bundles app component lines – they are sub-items of a bundle parent
          if (props["_bundle_key"]) return "";

          const title = item.product_title || item.title || "";
          const lineKey = getLineKey(item, index);
          const imageUrl = normalizeImageUrl(item.image);
          const image = imageUrl ? '<img src="' + imageUrl + '" alt="' + escapeHtml(title) + '">' : "";
          const linePrice = getLinePrice(item);
          const originalLinePrice = getOriginalLinePrice(item);
          const quantity = Math.max(1, Number(item.quantity || 1));
          const variantText = getVariantText(item);
          const compareMarkup = originalLinePrice > linePrice ? "<s>" + formatMoney(originalLinePrice, shopCurrency) + "</s>" : "";

          // Bundle contents – stored as private line item properties (_bundle_item_*)
          const bi1 = props["_bundle_item_1"] ? String(props["_bundle_item_1"]) : "";
          const bi2 = props["_bundle_item_2"] ? String(props["_bundle_item_2"]) : "";
          const bi3 = props["_bundle_item_3"] ? String(props["_bundle_item_3"]) : "";
          const bundleItemsMarkup = (bi1 || bi2 || bi3)
            ? '<ul class="cart-drawer__bundle-items">' +
              (bi1 ? "<li>" + escapeHtml(bi1) + "</li>" : "") +
              (bi2 ? "<li>" + escapeHtml(bi2) + "</li>" : "") +
              (bi3 ? "<li>" + escapeHtml(bi3) + "</li>" : "") +
              "</ul>"
            : "";

          return (
            '<article class="cart-drawer__item">' +
            '<a class="cart-drawer__item-media" href="' + (item.url || "/cart") + '">' + image + "</a>" +
            '<div class="cart-drawer__item-info">' +
            '<p class="cart-drawer__item-title">' + escapeHtml(title) + "</p>" +
            bundleItemsMarkup +
            (variantText ? '<p class="cart-drawer__item-variant">' + escapeHtml(variantText) + "</p>" : "") +
            '<div class="cart-drawer__item-row">' +
            '<div class="cart-drawer__qty">' +
            '<button type="button" aria-label="' + escapeHtml(getThemeString("cart.decreaseQuantity", "Decrease quantity")) + '" data-cart-qty-action="decrease" data-cart-line-key="' + escapeHtml(lineKey) + '" data-cart-current-qty="' + quantity + '">' +
            '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path></svg>' +
            "</button>" +
            "<span>" + quantity + "</span>" +
            '<button type="button" aria-label="' + escapeHtml(getThemeString("cart.increaseQuantity", "Increase quantity")) + '" data-cart-qty-action="increase" data-cart-line-key="' + escapeHtml(lineKey) + '" data-cart-current-qty="' + quantity + '">' +
            '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path></svg>' +
            "</button>" +
            "</div>" +
            '<div class="cart-drawer__item-prices">' +
            "<strong>" + formatMoney(linePrice, shopCurrency) + "</strong>" +
            compareMarkup +
            "</div>" +
            "</div>" +
            '<button type="button" class="cart-drawer__item-remove" data-cart-remove data-cart-line-key="' + escapeHtml(lineKey) + '">' + escapeHtml(getThemeString("cart.removeItem", "Remove")) + '</button>' +
            "</div>" +
            "</article>"
          );
        })
        .join("");

      itemsWrap.innerHTML =
        '<div class="cart-drawer__urgency is-hidden" data-cart-urgency><p>🔥 ' + escapeHtml(getThemeString("cart.urgency", "This product is very popular and selling fast — secure your order now!")) + '</p></div>' +
        '<div class="cart-drawer__items-list">' + markup + "</div>";

      updateUrgencyVisibility(safeItems);
    }

    function renderShopifyCart(cart) {
      renderCartItems(cart.items || [], cart.total_price || 0, cart.item_count || 0);
    }

    function renderMockCart() {
      const subtotal = mockCart.reduce(function (sum, item) {
        return sum + item.price_cents * item.quantity;
      }, 0);
      const count = mockCart.reduce(function (sum, item) {
        return sum + item.quantity;
      }, 0);
      renderCartItems(
        mockCart.map(function (item) {
          return {
            key: item.mock_key,
            product_title: item.product_title,
            url: item.url,
            image: item.image,
            quantity: item.quantity,
            pack: item.pack || "",
            final_line_price: item.price_cents * item.quantity,
            original_line_price: item.original_price_cents ? item.original_price_cents * item.quantity : item.price_cents * item.quantity,
            properties: {
              _is_best_seller: item.is_best_seller ? "1" : "0",
            },
          };
        }),
        subtotal,
        count
      );
    }

    async function fetchShopifyCart() {
      try {
        const response = await fetch(localizeInternalUrl("/cart.js"), { headers: { Accept: "application/json" } });
        if (!response.ok) return null;
        return await response.json();
      } catch (error) {
        return null;
      }
    }

    async function changeShopifyCartLine(lineKey, quantity) {
      try {
        const response = await fetch(localizeInternalUrl("/cart/change.js"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: lineKey,
            quantity: quantity,
          }),
        });
        if (!response.ok) return null;
        return await response.json();
      } catch (error) {
        return null;
      }
    }

    function updateMockLine(lineKey, quantity) {
      const index = mockCart.findIndex(function (item) {
        return item.mock_key === lineKey;
      });
      if (index === -1) return false;

      if (quantity <= 0) {
        mockCart.splice(index, 1);
      } else {
        mockCart[index].quantity = quantity;
      }
      renderMockCart();
      return true;
    }

    async function fetchAndRenderCart() {
      const cart = await fetchShopifyCart();
      if (cart && (cart.item_count > 0 || mockCart.length === 0)) {
        renderShopifyCart(cart);
        return true;
      }
      if (mockCart.length > 0) {
        renderMockCart();
        return true;
      }
      renderEmptyCart();
      return false;
    }

    function addMockItem(button) {
      const title = button.getAttribute("data-mock-title") || "Product";
      const url = button.getAttribute("data-mock-url") || "/cart";
      const image = button.getAttribute("data-mock-image") || "";
      const price = Number(button.getAttribute("data-mock-price-cents") || "0");
      const comparePrice = Number(button.getAttribute("data-mock-compare-price-cents") || String(price));
      const pack = button.getAttribute("data-mock-pack") || "";
      const isBestSeller = button.getAttribute("data-mock-best-seller") === "1";
      const existing = mockCart.find(function (item) {
        return item.product_title === title && item.url === url;
      });

      if (existing) {
        existing.quantity += 1;
        existing.is_best_seller = existing.is_best_seller || isBestSeller;
      } else {
        mockCart.push({
          product_title: title,
          url: url,
          image: image,
          pack: pack,
          is_best_seller: isBestSeller,
          mock_key: "mock::" + btoa(unescape(encodeURIComponent(title + "::" + url))).replace(/=+$/g, ""),
          price_cents: Number.isFinite(price) ? price : 0,
          original_price_cents: Number.isFinite(comparePrice) ? comparePrice : price,
          quantity: 1,
        });
      }

      renderMockCart();
      setOpen(true);
    }

    async function addFormToCart(form, options) {
      const shouldOpenDrawer = !options || options.openDrawer !== false;
      const formData = new FormData(form);
      const loadingControls = getSubmissionControls(form, options);

      form.setAttribute("aria-busy", "true");
      setElementsLoading(loadingControls, true);

      try {
        const response = await fetch(localizeInternalUrl("/cart/add.js"), {
          method: "POST",
          headers: { Accept: "application/json" },
          body: formData,
        });

        if (!response.ok) return false;
        mockCart.length = 0;
        await fetchAndRenderCart();
        if (shouldOpenDrawer) {
          setOpen(true);
        }
        return true;
      } catch (error) {
        return false;
      } finally {
        form.removeAttribute("aria-busy");
        setElementsLoading(loadingControls, false);
      }
    }

    for (const trigger of triggers) {
      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        fetchAndRenderCart().then(function () {
          setOpen(true);
        });
      });
    }

    for (const button of mockAddButtons) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        setElementLoading(button, true);

        window.requestAnimationFrame(function () {
          addMockItem(button);
          window.setTimeout(function () {
            setElementLoading(button, false);
          }, 180);
        });
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        setOpen(false);
      });
    }
    backdrop.addEventListener("click", function () {
      setOpen(false);
    });

    document.addEventListener("submit", function (event) {
      const target = event.target;
      if (!target || !(target instanceof HTMLFormElement)) return;
      if (!target.matches('form[action*="/cart/add"], .home-product-card__form')) return;
      if (target.closest("[data-cart-custom-page]")) return;

      event.preventDefault();

      const relatedControls = [];
      if (target._pendingExternalSubmitter instanceof Element) {
        relatedControls.push(target._pendingExternalSubmitter);
      }
      target._pendingExternalSubmitter = null;

      addFormToCart(target, {
        submitter: event.submitter instanceof Element ? event.submitter : null,
        relatedControls: relatedControls,
      });
    });

    itemsWrap.addEventListener("click", function (event) {
      const target = event.target;
      if (!(target instanceof Element) || isUpdating) return;

      const qtyButton = target.closest("[data-cart-qty-action]");
      if (qtyButton) {
        const lineKey = qtyButton.getAttribute("data-cart-line-key") || "";
        const currentQty = Number(qtyButton.getAttribute("data-cart-current-qty") || "1");
        const action = qtyButton.getAttribute("data-cart-qty-action");
        const nextQty = action === "increase" ? currentQty + 1 : currentQty - 1;
        const cartItem = qtyButton.closest(".cart-drawer__item");
        if (!lineKey || nextQty < 1) return;

        isUpdating = true;
        if (cartItem) {
          cartItem.classList.add("is-cart-pending");
        }
        setElementLoading(qtyButton, true);

        if (lineKey.indexOf("mock::") === 0) {
          updateMockLine(lineKey, nextQty);
          isUpdating = false;
          return;
        }
        changeShopifyCartLine(lineKey, nextQty)
          .then(function (cart) {
            if (cart) {
              renderShopifyCart(cart);
            } else {
              fetchAndRenderCart();
            }
          })
          .finally(function () {
            isUpdating = false;
            if (cartItem) {
              cartItem.classList.remove("is-cart-pending");
            }
            setElementLoading(qtyButton, false);
          });
        return;
      }

      const removeButton = target.closest("[data-cart-remove]");
      if (removeButton) {
        const lineKey = removeButton.getAttribute("data-cart-line-key") || "";
        const cartItem = removeButton.closest(".cart-drawer__item");
        if (!lineKey) return;

        isUpdating = true;
        if (cartItem) {
          cartItem.classList.add("is-cart-pending");
        }
        setElementLoading(removeButton, true);

        if (lineKey.indexOf("mock::") === 0) {
          updateMockLine(lineKey, 0);
          isUpdating = false;
          return;
        }
        changeShopifyCartLine(lineKey, 0)
          .then(function (cart) {
            if (cart) {
              renderShopifyCart(cart);
            } else {
              fetchAndRenderCart();
            }
          })
          .finally(function () {
            isUpdating = false;
            if (cartItem) {
              cartItem.classList.remove("is-cart-pending");
            }
            setElementLoading(removeButton, false);
          });
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && drawer.classList.contains("is-open")) {
        setOpen(false);
      }
    });

    fetchAndRenderCart();
  }

  function initPdpMain(main) {
    const hero = main.querySelector("[data-pdp-hero] img");
    const heroTrigger = main.querySelector("[data-pdp-hero-trigger]");
    const thumbs = Array.from(main.querySelectorAll("[data-pdp-thumb]"));
    const packButtons = Array.from(main.querySelectorAll("[data-pack-button]"));
    const variantInput = main.querySelector("[data-pdp-variant-input]");
    const priceEl = main.querySelector("[data-pdp-price]");
    const compareEl = main.querySelector("[data-pdp-compare]");
    const priceLabelEl = main.querySelector("[data-pdp-price-label]");
    const saveEl = main.querySelector("[data-pdp-save]");
    const discountEl = main.querySelector("[data-pdp-discount]");
    const qtyInputs = Array.from(main.querySelectorAll("[data-pdp-qty-input]"));
    const qtyInput = qtyInputs[0] || null;
    const qtyMinusButtons = Array.from(main.querySelectorAll("[data-pdp-qty-minus]"));
    const qtyPlusButtons = Array.from(main.querySelectorAll("[data-pdp-qty-plus]"));
    const qtyDisplays = Array.from(main.querySelectorAll("[data-pdp-qty-display]"));
    const qtyHiddenInputs = Array.from(main.querySelectorAll("[data-pdp-qty-hidden]"));
    const qtySummaries = Array.from(main.querySelectorAll("[data-pdp-qty-summary]"));
    const stickyBar = document.querySelector("[data-pdp-sticky-bar]");
    const stickyPriceEl = document.querySelector("[data-pdp-sticky-price]");
    const stickyCompareEl = document.querySelector("[data-pdp-sticky-compare]");
    const stickySaveEl = document.querySelector("[data-pdp-sticky-save]");
    const stickyAddButton = document.querySelector("[data-pdp-sticky-add]");
    const secondaryPriceEl = document.querySelector("[data-pdp-secondary-price]");
    const mainAddButton = main.querySelector('button[name="add"]');
    const buyNowButton = main.querySelector("[data-pdp-buy-now]");
    const mainAtcAnchor = document.getElementById("main-atc-btn");
    const lightbox = main.querySelector("[data-pdp-lightbox]");
    const lightboxDialog = main.querySelector("[data-pdp-lightbox-dialog]");
    const lightboxStage = main.querySelector("[data-pdp-lightbox-stage]");
    const lightboxImage = main.querySelector("[data-pdp-lightbox-image]");
    const lightboxCount = main.querySelector("[data-pdp-lightbox-count]");
    const lightboxZoomValue = main.querySelector("[data-pdp-lightbox-zoom-value]");
    const lightboxPrev = main.querySelector("[data-pdp-lightbox-prev]");
    const lightboxNext = main.querySelector("[data-pdp-lightbox-next]");
    const lightboxZoomIn = main.querySelector("[data-pdp-lightbox-zoom-in]");
    const lightboxZoomOut = main.querySelector("[data-pdp-lightbox-zoom-out]");
    const lightboxReset = main.querySelector("[data-pdp-lightbox-reset]");
    const lightboxCloseButtons = Array.from(main.querySelectorAll("[data-pdp-lightbox-close]"));
    const MIN_LIGHTBOX_ZOOM = 1;
    const MAX_LIGHTBOX_ZOOM = 3;
    const LIGHTBOX_ZOOM_STEP = 0.5;
    let lightboxIndex = Math.max(thumbs.findIndex(function (thumb) {
      return thumb.classList.contains("is-active");
    }), 0);
    let lightboxZoom = 1;
    let lightboxPanX = 0;
    let lightboxPanY = 0;
    let lightboxDragging = false;
    let lightboxDragOriginX = 0;
    let lightboxDragOriginY = 0;

    function isLightboxOpen() {
      return Boolean(lightbox) && !lightbox.hidden;
    }

    function getThumbPayload(thumb) {
      return {
        imageUrl: thumb ? thumb.getAttribute("data-image-url") || "" : "",
        imageSrcset: thumb ? thumb.getAttribute("data-image-srcset") || "" : "",
        imageAlt:
          (thumb && thumb.getAttribute("data-image-alt"))
          || (thumb && thumb.querySelector("img") && thumb.querySelector("img").getAttribute("alt"))
          || ""
      };
    }

    function applyHeroPayload(payload) {
      if (!hero || !payload.imageUrl) return;
      hero.setAttribute("src", payload.imageUrl);
      if (payload.imageSrcset) {
        hero.setAttribute("srcset", payload.imageSrcset);
      } else {
        hero.removeAttribute("srcset");
      }
      if (payload.imageAlt) {
        hero.setAttribute("alt", payload.imageAlt);
      }
    }

    function setActiveThumb(thumb) {
      if (!thumb) return;
      const payload = getThumbPayload(thumb);
      applyHeroPayload(payload);
      for (const item of thumbs) item.classList.remove("is-active");
      thumb.classList.add("is-active");
      const nextIndex = thumbs.indexOf(thumb);
      if (nextIndex >= 0) {
        lightboxIndex = nextIndex;
      }
    }

    function clampLightboxPan() {
      if (!lightboxStage || !lightboxImage || lightboxZoom <= MIN_LIGHTBOX_ZOOM) {
        lightboxPanX = 0;
        lightboxPanY = 0;
        return;
      }

      const stageWidth = lightboxStage.clientWidth;
      const stageHeight = lightboxStage.clientHeight;
      const baseWidth = lightboxImage.offsetWidth;
      const baseHeight = lightboxImage.offsetHeight;
      if (!stageWidth || !stageHeight || !baseWidth || !baseHeight) {
        lightboxPanX = 0;
        lightboxPanY = 0;
        return;
      }

      const maxPanX = Math.max(0, (baseWidth * lightboxZoom - stageWidth) / 2);
      const maxPanY = Math.max(0, (baseHeight * lightboxZoom - stageHeight) / 2);
      lightboxPanX = Math.min(maxPanX, Math.max(-maxPanX, lightboxPanX));
      lightboxPanY = Math.min(maxPanY, Math.max(-maxPanY, lightboxPanY));
    }

    function syncLightboxTransform() {
      if (!lightboxImage || !lightboxStage) return;
      clampLightboxPan();
      lightboxImage.style.setProperty("--pdp-lightbox-scale", String(lightboxZoom));
      lightboxImage.style.setProperty("--pdp-lightbox-pan-x", lightboxPanX + "px");
      lightboxImage.style.setProperty("--pdp-lightbox-pan-y", lightboxPanY + "px");
      lightboxStage.classList.toggle("is-zoomed", lightboxZoom > MIN_LIGHTBOX_ZOOM);
      if (lightboxZoomValue) {
        lightboxZoomValue.textContent = Math.round(lightboxZoom * 100) + "%";
      }
      if (lightboxZoomOut) {
        lightboxZoomOut.disabled = lightboxZoom <= MIN_LIGHTBOX_ZOOM;
      }
      if (lightboxZoomIn) {
        lightboxZoomIn.disabled = lightboxZoom >= MAX_LIGHTBOX_ZOOM;
      }
      if (lightboxReset) {
        lightboxReset.disabled = lightboxZoom === MIN_LIGHTBOX_ZOOM && lightboxPanX === 0 && lightboxPanY === 0;
      }
    }

    function resetLightboxView() {
      lightboxZoom = MIN_LIGHTBOX_ZOOM;
      lightboxPanX = 0;
      lightboxPanY = 0;
      if (lightboxStage) {
        lightboxStage.classList.remove("is-dragging");
      }
      syncLightboxTransform();
    }

    function setLightboxZoom(nextZoom) {
      const clampedZoom = Math.min(MAX_LIGHTBOX_ZOOM, Math.max(MIN_LIGHTBOX_ZOOM, nextZoom));
      lightboxZoom = clampedZoom;
      if (lightboxZoom === MIN_LIGHTBOX_ZOOM) {
        lightboxPanX = 0;
        lightboxPanY = 0;
      }
      syncLightboxTransform();
    }

    function updateLightboxImage() {
      if (!lightboxImage || !thumbs.length) return;
      const activeThumb = thumbs[lightboxIndex] || thumbs[0];
      if (!activeThumb) return;

      setActiveThumb(activeThumb);
      const payload = getThumbPayload(activeThumb);
      lightboxImage.setAttribute("src", payload.imageUrl);
      if (payload.imageSrcset) {
        lightboxImage.setAttribute("srcset", payload.imageSrcset);
      } else {
        lightboxImage.removeAttribute("srcset");
      }
      if (payload.imageAlt) {
        lightboxImage.setAttribute("alt", payload.imageAlt);
      }
      if (lightboxCount) {
        lightboxCount.textContent = (lightboxIndex + 1) + " / " + thumbs.length;
      }
      if (lightboxPrev) {
        lightboxPrev.disabled = thumbs.length <= 1;
      }
      if (lightboxNext) {
        lightboxNext.disabled = thumbs.length <= 1;
      }
      resetLightboxView();
    }

    function setLightboxOpen(nextOpen) {
      if (!lightbox) return;
      lightbox.hidden = !nextOpen;
      lightbox.setAttribute("aria-hidden", nextOpen ? "false" : "true");
      document.body.classList.toggle("is-pdp-lightbox-open", nextOpen);
      if (!nextOpen) {
        lightboxDragging = false;
        resetLightboxView();
        return;
      }

      const activeThumb = main.querySelector("[data-pdp-thumb].is-active") || thumbs[0];
      const activeIndex = thumbs.indexOf(activeThumb);
      lightboxIndex = activeIndex >= 0 ? activeIndex : 0;
      updateLightboxImage();
      window.requestAnimationFrame(function () {
        if (lightboxDialog && typeof lightboxDialog.focus === "function") {
          lightboxDialog.focus();
        }
      });
    }

    function goToAdjacentLightboxImage(step) {
      if (thumbs.length <= 1) return;
      lightboxIndex = (lightboxIndex + step + thumbs.length) % thumbs.length;
      updateLightboxImage();
    }

    for (const thumb of thumbs) {
      thumb.addEventListener("click", function () {
        setActiveThumb(thumb);
        if (isLightboxOpen()) {
          updateLightboxImage();
        }
      });
    }

    if (heroTrigger && lightbox && thumbs.length) {
      heroTrigger.addEventListener("click", function () {
        setLightboxOpen(true);
      });

      heroTrigger.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          setLightboxOpen(true);
        }
      });
    }

    for (const closeButton of lightboxCloseButtons) {
      closeButton.addEventListener("click", function () {
        setLightboxOpen(false);
      });
    }

    if (lightboxPrev) {
      lightboxPrev.addEventListener("click", function () {
        goToAdjacentLightboxImage(-1);
      });
    }

    if (lightboxNext) {
      lightboxNext.addEventListener("click", function () {
        goToAdjacentLightboxImage(1);
      });
    }

    if (lightboxZoomIn) {
      lightboxZoomIn.addEventListener("click", function () {
        setLightboxZoom(lightboxZoom + LIGHTBOX_ZOOM_STEP);
      });
    }

    if (lightboxZoomOut) {
      lightboxZoomOut.addEventListener("click", function () {
        setLightboxZoom(lightboxZoom - LIGHTBOX_ZOOM_STEP);
      });
    }

    if (lightboxReset) {
      lightboxReset.addEventListener("click", function () {
        resetLightboxView();
      });
    }

    if (lightboxImage) {
      lightboxImage.addEventListener("load", function () {
        syncLightboxTransform();
      });
    }

    if (lightboxStage) {
      lightboxStage.addEventListener("wheel", function (event) {
        if (!isLightboxOpen()) return;
        event.preventDefault();
        setLightboxZoom(lightboxZoom + (event.deltaY < 0 ? LIGHTBOX_ZOOM_STEP : -LIGHTBOX_ZOOM_STEP));
      }, { passive: false });

      lightboxStage.addEventListener("dblclick", function () {
        setLightboxZoom(lightboxZoom > MIN_LIGHTBOX_ZOOM ? MIN_LIGHTBOX_ZOOM : 2);
      });

      lightboxStage.addEventListener("pointerdown", function (event) {
        if (!isLightboxOpen() || lightboxZoom <= MIN_LIGHTBOX_ZOOM || event.button !== 0) return;
        lightboxDragging = true;
        lightboxDragOriginX = event.clientX - lightboxPanX;
        lightboxDragOriginY = event.clientY - lightboxPanY;
        lightboxStage.classList.add("is-dragging");
        if (typeof lightboxStage.setPointerCapture === "function") {
          lightboxStage.setPointerCapture(event.pointerId);
        }
      });

      lightboxStage.addEventListener("pointermove", function (event) {
        if (!lightboxDragging) return;
        event.preventDefault();
        lightboxPanX = event.clientX - lightboxDragOriginX;
        lightboxPanY = event.clientY - lightboxDragOriginY;
        syncLightboxTransform();
      });

      const stopLightboxDrag = function (event) {
        if (!lightboxDragging) return;
        lightboxDragging = false;
        lightboxStage.classList.remove("is-dragging");
        if (event && typeof lightboxStage.releasePointerCapture === "function") {
          try {
            lightboxStage.releasePointerCapture(event.pointerId);
          } catch (error) {
          }
        }
      };

      lightboxStage.addEventListener("pointerup", stopLightboxDrag);
      lightboxStage.addEventListener("pointercancel", stopLightboxDrag);
      lightboxStage.addEventListener("pointerleave", stopLightboxDrag);
    }

    document.addEventListener("keydown", function (event) {
      if (!isLightboxOpen()) return;
      if (event.key === "Escape") {
        setLightboxOpen(false);
      } else if (event.key === "ArrowLeft") {
        goToAdjacentLightboxImage(-1);
      } else if (event.key === "ArrowRight") {
        goToAdjacentLightboxImage(1);
      } else if (event.key === "+" || event.key === "=") {
        event.preventDefault();
        setLightboxZoom(lightboxZoom + LIGHTBOX_ZOOM_STEP);
      } else if (event.key === "-" || event.key === "_") {
        event.preventDefault();
        setLightboxZoom(lightboxZoom - LIGHTBOX_ZOOM_STEP);
      }
    });

    window.addEventListener("resize", function () {
      if (isLightboxOpen()) {
        syncLightboxTransform();
      }
    });

    const shopCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "EGP";

    function getSelectedPackButton() {
      return main.querySelector("[data-pack-button].is-selected") || packButtons[0] || null;
    }

    function getQuantityMax() {
      let max = null;
      for (const input of qtyInputs) {
        const inputMax = Number(input.getAttribute("max"));
        if (!Number.isFinite(inputMax) || inputMax < 1) continue;
        max = max === null ? inputMax : Math.min(max, inputMax);
      }
      return max;
    }

    function clampPdpQuantity(value) {
      const parsed = Number(value);
      let quantity = Number.isFinite(parsed) ? Math.round(parsed) : 1;
      quantity = Math.max(1, quantity);
      const max = getQuantityMax();
      if (max !== null) {
        quantity = Math.min(max, quantity);
      }
      return quantity;
    }

    function getPdpQuantity() {
      if (!qtyInput) return 1;
      return clampPdpQuantity(qtyInput.value);
    }

    function syncPdpQuantityFields(quantity, unitPrice, totalPrice) {
      for (const input of qtyInputs) {
        input.value = String(quantity);
      }
      for (const input of qtyHiddenInputs) {
        input.value = String(quantity);
      }
      for (const display of qtyDisplays) {
        display.textContent = String(quantity);
      }
      for (const summary of qtySummaries) {
        summary.textContent = quantity > 1 && Number.isFinite(unitPrice) && Number.isFinite(totalPrice)
          ? quantity + " × " + formatMoney(unitPrice, shopCurrency) + " = " + formatMoney(totalPrice, shopCurrency)
          : "";
      }
    }

    function syncPdpPricing(packButton, nextQuantity) {
      const button = packButton || getSelectedPackButton();
      if (!button) return;

      const variantId = button.getAttribute("data-variant-id");
      const unitPrice = Number(button.getAttribute("data-price"));
      const unitCompare = Number(button.getAttribute("data-compare"));
      const quantity = qtyInput ? clampPdpQuantity(nextQuantity !== undefined ? nextQuantity : getPdpQuantity()) : 1;
      const price = Number.isFinite(unitPrice) ? unitPrice * quantity : unitPrice;
      const compare = Number.isFinite(unitCompare) ? unitCompare * quantity : unitCompare;
      const label = button.getAttribute("data-label") || "";
      const save = button.getAttribute("data-save") || "";
      const discount = button.getAttribute("data-discount") || "";
      const hasSaleMeta = save.trim() !== "" || discount.trim() !== "";
      const hasComparePrice = Number.isFinite(compare) && Number.isFinite(price) && compare > price && hasSaleMeta;
      const quantityLabel = qtyInput && quantity > 1 && Number.isFinite(unitPrice)
        ? quantity + " units × " + formatMoney(unitPrice, shopCurrency)
        : label;

      if (variantInput && variantId) {
        variantInput.value = variantId;
      }
      if (priceEl) {
        priceEl.textContent = formatMoney(price, shopCurrency);
      }
      if (compareEl) {
        compareEl.textContent = hasComparePrice ? formatMoney(compare, shopCurrency) : "";
        compareEl.hidden = !hasComparePrice;
      }
      if (stickyPriceEl) {
        stickyPriceEl.textContent = formatMoney(price, shopCurrency);
      }
      if (stickyCompareEl) {
        stickyCompareEl.textContent = hasComparePrice ? formatMoney(compare, shopCurrency) : "";
        stickyCompareEl.hidden = !hasComparePrice;
      }
      if (stickySaveEl) {
        if (hasComparePrice && compare > 0) {
          const pct = Math.round((compare - price) * 100 / compare);
          stickySaveEl.textContent = "Save " + pct + "%";
          stickySaveEl.style.display = "";
        } else {
          stickySaveEl.textContent = "";
          stickySaveEl.style.display = "none";
        }
      }
      if (secondaryPriceEl) {
        secondaryPriceEl.textContent = formatMoney(price, shopCurrency);
      }
      if (priceLabelEl) {
        priceLabelEl.textContent = quantityLabel;
      }
      if (saveEl) {
        saveEl.textContent = save;
      }
      if (discountEl) {
        discountEl.textContent = discount;
      }

      syncPdpQuantityFields(quantity, unitPrice, price);
    }

    for (const button of packButtons) {
      button.addEventListener("click", function () {
        for (const item of packButtons) item.classList.remove("is-selected");
        button.classList.add("is-selected");

        syncPdpPricing(button);
      });
    }

    if (qtyInput) {
      for (const button of qtyMinusButtons) {
        button.addEventListener("click", function () {
          syncPdpPricing(null, getPdpQuantity() - 1);
        });
      }
      for (const button of qtyPlusButtons) {
        button.addEventListener("click", function () {
          syncPdpPricing(null, getPdpQuantity() + 1);
        });
      }
      for (const input of qtyInputs) {
        input.addEventListener("input", function () {
          syncPdpPricing(null, input.value);
        });
        input.addEventListener("change", function () {
          syncPdpPricing(null, input.value);
        });
      }
    }

    if (stickyAddButton && mainAddButton) {
      stickyAddButton.addEventListener("click", function () {
        const form = main.querySelector("form.pdp-main__form, form.bundle-product__cta");

        if (!form) {
          mainAddButton.click();
          return;
        }

        form._pendingExternalSubmitter = stickyAddButton;
        if (typeof form.requestSubmit === "function") {
          form.requestSubmit(mainAddButton);
        } else {
          mainAddButton.click();
        }
      });
    }

    if (buyNowButton) {
      buyNowButton.addEventListener("click", function () {
        const form = main.querySelector("form.pdp-main__form, form.bundle-product__cta");
        if (!form) return;

        const formData = new FormData(form);
              // Pack quantity fix: if a multi-pack is selected, use single variant with correct quantity
                    const selectedPack = main.querySelector("[data-pack-button].is-selected");
                          if (selectedPack) {
                                  const packCount = parseInt(selectedPack.dataset.packCount) || 1;
                                          const singlePack = main.querySelector("[data-pack-button][data-pack-count='1']");
                                                  if (packCount > 1 && singlePack) {
                                                            formData.set("id", singlePack.dataset.variantId);
                                                                      formData.set("quantity", packCount);
                                                                              }
                                                                                    }
        buyNowButton.setAttribute("aria-busy", "true");
        buyNowButton.disabled = true;

        // Buy Now: replace the cart with ONLY this product, then go to
        // checkout. Clears any existing items so the shopper checks out
        // with this product alone.
        fetch(localizeInternalUrl("/cart/clear.js"), {
          method: "POST",
          headers: { Accept: "application/json" },
        })
          .then(function () {
            return fetch(localizeInternalUrl("/cart/add.js"), {
              method: "POST",
              headers: { Accept: "application/json" },
              body: formData,
            });
          })
          .then(function (response) {
            if (!response.ok) throw new Error("add failed");
            submitLocalizedCheckout();
          })
          .catch(function () {
            buyNowButton.removeAttribute("aria-busy");
            buyNowButton.disabled = false;
          });
      });
    }

    if (stickyBar && mainAtcAnchor) {
      const toggleSticky = function () {
        const rect = mainAtcAnchor.getBoundingClientRect();
        const shouldShow = rect.bottom < 0;
        stickyBar.classList.toggle("is-visible", shouldShow);
      };

      toggleSticky();
      window.addEventListener("scroll", toggleSticky, { passive: true });
      window.addEventListener("resize", toggleSticky);
    }
  }

  function initHeaderMegaMenu() {
    const megaWrap = document.querySelector("[data-mega-wrap]");
    const megaTrigger = document.querySelector("[data-mega-trigger-link]");
    const megaMenu = document.querySelector("[data-mega-menu]");
    const goalLinks = document.querySelectorAll("[data-mega-goal]");
    const megaRight = document.querySelector("[data-mega-right]");
    const megaRightLabel = document.querySelector("[data-mega-right-label]");
    const megaProducts = document.querySelector("[data-mega-products]");

    if (megaWrap && megaWrap.getAttribute("data-mega-managed") === "inline") return;
    if (!megaWrap || !megaTrigger || !megaMenu) return;

    let isOpen = false;
    let hoverTimeout = null;

    function openMega() {
      isOpen = true;
      megaMenu.classList.add("is-open");
      megaMenu.setAttribute("aria-hidden", "false");
      megaTrigger.classList.add("is-active");
      megaTrigger.setAttribute("aria-expanded", "true");
    }

    function closeMega() {
      isOpen = false;
      megaMenu.classList.remove("is-open");
      megaMenu.setAttribute("aria-hidden", "true");
      megaTrigger.classList.remove("is-active");
      megaTrigger.setAttribute("aria-expanded", "false");
    }

    megaTrigger.addEventListener("mouseenter", function () {
      clearTimeout(hoverTimeout);
      hoverTimeout = setTimeout(openMega, 150);
    });

    megaWrap.addEventListener("mouseleave", function () {
      clearTimeout(hoverTimeout);
      hoverTimeout = setTimeout(closeMega, 200);
    });

    document.addEventListener("click", function (event) {
      if (!megaWrap.contains(event.target) && isOpen) {
        closeMega();
      }
    });

    for (const link of goalLinks) {
      link.addEventListener("mouseenter", function () {
        const goalName = link.getAttribute("data-mega-goal") || "";
        if (megaRightLabel) {
          megaRightLabel.textContent = goalName;
        }

        for (const otherLink of goalLinks) {
          otherLink.classList.remove("is-active");
        }
        link.classList.add("is-active");
      });
    }
  }

  function initLegacyShopifyResourceLinks() {
    const selector = [
      'a[href="/collections/bundles"]',
      'a[href="/pages/about"]',
      'a[href="/about"]',
      'a[href="/pages/contact"]',
      'a[href="/contact"]',
    ].join(",");
    const anchors = Array.from(document.querySelectorAll(selector));
    if (!anchors.length) return;

    const validationCache = new Map();
    const resolutionCache = new Map();

    function stripUrl(input) {
      try {
        const url = new URL(input, window.location.origin);
        return url.pathname;
      } catch (error) {
        return String(input || "").split("?")[0].split("#")[0] || "";
      }
    }

    function isCollectionHref(href) {
      return stripUrl(href).indexOf("/collections/") !== -1;
    }

    function getQuery(anchor) {
      const explicit = (anchor.getAttribute("data-shopify-resource-query") || "").trim();
      if (explicit) return explicit;
      const text = (anchor.textContent || "").replace(/\s+/g, " ").trim();
      if (text) return text;
      const href = stripUrl(anchor.getAttribute("href") || "");
      return href.split("/").filter(Boolean).pop() || "";
    }

    function validatePath(pathname) {
      const cleanPath = stripUrl(pathname);
      if (!cleanPath) return Promise.resolve("");
      if (!validationCache.has(cleanPath)) {
        validationCache.set(
          cleanPath,
          fetch(cleanPath, {
            method: "GET",
            headers: { Accept: "text/html" },
            credentials: "same-origin",
          })
            .then((response) => (response.ok ? cleanPath : ""))
            .catch(() => "")
        );
      }
      return validationCache.get(cleanPath);
    }

    function resolvePath(type, query) {
      const normalizedQuery = String(query || "").trim();
      if (!normalizedQuery) return Promise.resolve("");
      const cacheKey = `${type}:${normalizedQuery.toLowerCase()}`;
      if (!resolutionCache.has(cacheKey)) {
        const endpoint = `/search/suggest.json?q=${encodeURIComponent(normalizedQuery)}&resources[type]=${type}&resources[limit]=5`;
        resolutionCache.set(
          cacheKey,
          fetch(endpoint, {
            method: "GET",
            headers: { Accept: "application/json" },
            credentials: "same-origin",
          })
            .then((response) => (response.ok ? response.json() : null))
            .then((payload) => {
              const key = `${type}s`;
              const results =
                payload &&
                payload.resources &&
                payload.resources.results &&
                Array.isArray(payload.resources.results[key])
                  ? payload.resources.results[key]
                  : [];
              const hit = results.find((entry) => entry && entry.url);
              return hit ? localizeInternalUrl(stripUrl(hit.url)) : "";
            })
            .catch(() => "")
        );
      }
      return resolutionCache.get(cacheKey);
    }

    function syncHeaderState(anchor) {
      const currentPath = stripUrl(window.location.pathname || "/") || "/";
      const targetPath = stripUrl(anchor.getAttribute("href") || "") || "/";
      const isActive = currentPath === targetPath;
      if (anchor.classList.contains("header-nav__link") || anchor.classList.contains("header-mobile-drawer__nav-link")) {
        anchor.classList.toggle("is-active", isActive);
      }
      if (isActive) {
        anchor.setAttribute("aria-current", "page");
      } else {
        anchor.removeAttribute("aria-current");
      }
    }

    anchors.forEach((anchor) => {
      const originalHref = anchor.getAttribute("href") || "";
      const type = isCollectionHref(originalHref) ? "collection" : "page";
      const localizedOriginalHref = localizeInternalUrl(originalHref);
      validatePath(localizedOriginalHref)
        .then((validPath) => {
          if (validPath) {
            anchor.setAttribute("href", validPath);
            syncHeaderState(anchor);
            return "";
          }
          return resolvePath(type, getQuery(anchor));
        })
        .then((resolvedPath) => {
          if (!resolvedPath) return;
          anchor.setAttribute("href", resolvedPath);
          syncHeaderState(anchor);
        })
        .catch(() => {});
    });
  }

  function initHeaderSearch() {
    const searchForm = document.querySelector("[data-header-search-form]");
    const toggleBtn = document.querySelector("[data-header-search-open]");
    const searchField = document.querySelector("[data-header-search-field]");
    const searchInput = document.querySelector("[data-header-search-input]");
    const closeBtn = document.querySelector("[data-header-search-close]");

    if (!searchForm || !toggleBtn || !searchField || !searchInput || !closeBtn) return;

    function openSearch() {
      toggleBtn.hidden = true;
      searchField.hidden = false;
      toggleBtn.setAttribute("aria-expanded", "true");
      searchInput.focus();
    }

    function closeSearch() {
      searchField.hidden = true;
      toggleBtn.hidden = false;
      toggleBtn.setAttribute("aria-expanded", "false");
      searchInput.value = "";
    }

    toggleBtn.addEventListener("click", openSearch);
    closeBtn.addEventListener("click", closeSearch);

    searchInput.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeSearch();
      }
    });
  }

  function initMobileNav() {
    const toggle = document.querySelector("[data-mobile-nav-toggle]");
    const drawer = document.querySelector("[data-mobile-nav-drawer]");
    const backdrop = document.querySelector("[data-mobile-nav-backdrop]");
    const closeTriggers = document.querySelectorAll("[data-mobile-nav-close]");
    const mobileSearchInput = document.querySelector("[data-mobile-search-input]");
    const mobileSearchSuggestions = document.querySelector("[data-mobile-search-suggestions]");
    const mobileSearchStatus = document.querySelector("[data-mobile-search-status]");
    const mobileSearchList = document.querySelector("[data-mobile-search-list]");

    if (!toggle || !drawer || !backdrop) return;

    let mobileSearchDebounceTimer = null;
    let mobileSearchAbortController = null;
    let mobileLatestSearchToken = 0;

    function escapeHtml(value) {
      return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/\"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    function normalizeProducts(payload) {
      if (!payload || !payload.resources || !payload.resources.results) return [];
      const products = payload.resources.results.products;
      return Array.isArray(products) ? products : [];
    }

    function normalizeImageUrl(url) {
      if (!url) return "";
      const normalized = String(url);
      if (normalized.indexOf("//") === 0) {
        return "https:" + normalized;
      }
      return normalized;
    }

    function getProductImageUrl(product) {
      if (!product) return "";
      if (product.image) {
        if (typeof product.image === "string") return normalizeImageUrl(product.image);
        if (product.image.url) return normalizeImageUrl(product.image.url);
        if (product.image.src) return normalizeImageUrl(product.image.src);
      }
      if (product.featured_image) {
        if (typeof product.featured_image === "string") return normalizeImageUrl(product.featured_image);
        if (product.featured_image.url) return normalizeImageUrl(product.featured_image.url);
        if (product.featured_image.src) return normalizeImageUrl(product.featured_image.src);
      }
      return "";
    }

    function showMobileSuggestions() {
      if (mobileSearchSuggestions) {
        mobileSearchSuggestions.hidden = false;
      }
    }

    function hideMobileSuggestions() {
      if (mobileSearchSuggestions) {
        mobileSearchSuggestions.hidden = true;
      }
    }

    function setMobileSearchStatus(text) {
      if (!mobileSearchStatus) return;
      mobileSearchStatus.textContent = text;
      mobileSearchStatus.hidden = false;
    }

    function clearMobileSearchItems() {
      if (mobileSearchList) {
        mobileSearchList.innerHTML = "";
      }
    }

    function renderMobileSearchItems(products) {
      if (!mobileSearchList) return;

      mobileSearchList.innerHTML = products.map(function (product) {
        const imageUrl = getProductImageUrl(product);
        const imageMarkup = imageUrl
          ? '<img class="header-mobile-search-suggestions__thumb" src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(product.title || "") + '" loading="lazy">'
          : '<span class="header-mobile-search-suggestions__thumb header-mobile-search-suggestions__thumb--empty" aria-hidden="true"></span>';

        let priceMarkup = "";
        if (product.price && product.price !== "0" && product.price !== "0.0") {
          priceMarkup = '<small>' + escapeHtml(product.price) + '</small>';
        }

        const targetUrl = product.url || ("/search?q=" + encodeURIComponent(product.title || "") + "&type=product");

        return (
          '<a class="header-mobile-search-suggestions__item" href="' + escapeHtml(targetUrl) + '">' +
            imageMarkup +
            '<span class="header-mobile-search-suggestions__meta">' +
              '<strong>' + escapeHtml(product.title || "") + '</strong>' +
              priceMarkup +
            '</span>' +
          '</a>'
        );
      }).join("");
    }

    function resetMobileSearch() {
      if (mobileSearchInput) {
        mobileSearchInput.value = "";
      }

      if (mobileSearchDebounceTimer) {
        clearTimeout(mobileSearchDebounceTimer);
        mobileSearchDebounceTimer = null;
      }

      if (mobileSearchAbortController) {
        mobileSearchAbortController.abort();
        mobileSearchAbortController = null;
      }

      clearMobileSearchItems();
      hideMobileSuggestions();
    }

    function handleMobileSearchInput() {
      if (!mobileSearchInput) return;

      const query = (mobileSearchInput.value || "").trim();

      if (mobileSearchDebounceTimer) {
        clearTimeout(mobileSearchDebounceTimer);
      }

      if (query.length < 3) {
        clearMobileSearchItems();
        hideMobileSuggestions();
        if (mobileSearchAbortController) {
          mobileSearchAbortController.abort();
          mobileSearchAbortController = null;
        }
        return;
      }

      showMobileSuggestions();
      clearMobileSearchItems();
      setMobileSearchStatus((window.themeStrings && window.themeStrings.header && window.themeStrings.header.searchLoading) || "Searching...");

      mobileSearchDebounceTimer = setTimeout(function () {
        if (mobileSearchAbortController) {
          mobileSearchAbortController.abort();
        }

        mobileSearchAbortController = new AbortController();
        mobileLatestSearchToken += 1;
        const token = mobileLatestSearchToken;
        const endpoint = "/search/suggest.json?q=" + encodeURIComponent(query) + "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide";

        fetch(endpoint, {
          method: "GET",
          headers: { Accept: "application/json" },
          signal: mobileSearchAbortController.signal
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error("Search request failed");
            }
            return response.json();
          })
          .then(function (payload) {
            if (token !== mobileLatestSearchToken) return;
            const products = normalizeProducts(payload);
            if (!products.length) {
              clearMobileSearchItems();
              setMobileSearchStatus((window.themeStrings && window.themeStrings.header && window.themeStrings.header.searchNoResults) || "No products found.");
              return;
            }

            if (mobileSearchStatus) {
              mobileSearchStatus.hidden = true;
            }
            renderMobileSearchItems(products);
          })
          .catch(function (error) {
            if (error && error.name === "AbortError") return;
            clearMobileSearchItems();
            setMobileSearchStatus((window.themeStrings && window.themeStrings.header && window.themeStrings.header.searchUnavailable) || "Search unavailable.");
          });
      }, 220);
    }

    function handleMobileSearchEnter(event) {
      if (event.key !== "Enter") return;

      const query = (mobileSearchInput && mobileSearchInput.value ? mobileSearchInput.value : "").trim();
      if (!query.length) {
        event.preventDefault();
        return;
      }

      const firstSuggestion = mobileSearchList ? mobileSearchList.querySelector(".header-mobile-search-suggestions__item") : null;
      event.preventDefault();
      if (firstSuggestion && query.length >= 3) {
        window.location.href = firstSuggestion.getAttribute("href");
      } else {
        window.location.href = localizeInternalUrl("/search?q=" + encodeURIComponent(query) + "&type=product");
      }
    }

    function openDrawer() {
      drawer.classList.add("is-open");
      backdrop.classList.add("is-open");
      document.body.classList.add("mobile-nav-open");
      toggle.setAttribute("aria-expanded", "true");
      drawer.setAttribute("aria-hidden", "false");
    }

    function closeDrawer() {
      drawer.classList.remove("is-open");
      backdrop.classList.remove("is-open");
      document.body.classList.remove("mobile-nav-open");
      toggle.setAttribute("aria-expanded", "false");
      drawer.setAttribute("aria-hidden", "true");
      if (mobileSearchInput) {
        mobileSearchInput.blur();
      }
      resetMobileSearch();
    }

    toggle.addEventListener("click", function () {
      if (drawer.classList.contains("is-open")) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    for (const trigger of closeTriggers) {
      trigger.addEventListener("click", closeDrawer);
    }

    if (mobileSearchInput) {
      mobileSearchInput.addEventListener("input", handleMobileSearchInput);
      mobileSearchInput.addEventListener("keydown", handleMobileSearchEnter);
      mobileSearchInput.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
          mobileSearchInput.value = "";
          resetMobileSearch();
          mobileSearchInput.blur();
        }
      });
    }

    window.addEventListener("resize", function () {
      if (window.innerWidth >= 1024) {
        closeDrawer();
      }
    });
  }

  function initCategoryFilters() {
    const pages = document.querySelectorAll("[data-category-page]");
    if (!pages.length) return;

    for (const page of pages) {
      const openBtn = page.querySelector("[data-category-mobile-open]");
      const closeBtn = page.querySelector("[data-category-mobile-close]");
      const sidebar = page.querySelector("[data-category-sidebar]");
      const backdrop = page.querySelector("[data-category-mobile-backdrop]");

      if (!openBtn || !closeBtn || !sidebar || !backdrop) continue;

      const openSidebar = function () {
        sidebar.classList.add("is-open");
        backdrop.classList.add("is-open");
        document.body.classList.add("mobile-nav-open");
      };

      const closeSidebar = function () {
        sidebar.classList.remove("is-open");
        backdrop.classList.remove("is-open");
        document.body.classList.remove("mobile-nav-open");
      };

      openBtn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        openSidebar();
      });
      closeBtn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeSidebar();
      });
      backdrop.addEventListener("click", closeSidebar);
      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && sidebar.classList.contains("is-open")) {
          closeSidebar();
        }
      });
      sidebar.addEventListener("click", function (event) {
        if (event.target && event.target.matches("[data-category-mobile-close]")) {
          closeSidebar();
        }
      });

      window.addEventListener("resize", function () {
        if (window.innerWidth > 900) {
          closeSidebar();
        }
      });
    }
  }

  function initAllProductsPage() {
    const pages = document.querySelectorAll("[data-all-products-page]");
    if (!pages.length) return;

    const isMobileViewport = function () {
      return window.matchMedia("(max-width: 1023px)").matches;
    };

    for (const page of pages) {
      if (page.dataset.allProductsThemeJsReady === "true") continue;
      page.dataset.allProductsThemeJsReady = "true";

      const form =
        page.querySelector("#AllProductsFiltersForm") ||
        page.querySelector(".all-products-page__filters-sidebar form");
      const sidebar = page.querySelector(".all-products-page__filters-sidebar");
      const mobileOpenBtn = page.querySelector(".all-products-page__mobile-filter-button");
      const sortSelect =
        page.querySelector("#AllProductsSort") ||
        page.querySelector("[data-all-products-sort]");

      if (!form || !sidebar) continue;

      let isSubmitting = false;
      let isMobileDrawerOpen = false;
      let mobilePendingChanges = false;

      form.querySelectorAll("input[disabled], select[disabled]").forEach(function (field) {
        field.disabled = false;
      });
      if (sortSelect && sortSelect.disabled) {
        sortSelect.disabled = false;
      }

      const submitForm = function () {
        if (isSubmitting) return;
        isSubmitting = true;
        if (typeof form.requestSubmit === "function") {
          form.requestSubmit();
        } else {
          form.submit();
        }
      };

      const headingSelector = [
        "[data-all-products-filter-heading]",
        "button.all-products-page__filter-heading",
      ].join(", ");

      const resolveHeadingOptions = function (heading) {
        if (!heading) return null;
        const next = heading.nextElementSibling;
        if (next && next.classList.contains("all-products-page__filter-options")) {
          return next;
        }
        const group = heading.closest(
          "[data-all-products-filter-group], .all-products-page__filter-group"
        );
        if (!group) return null;
        return group.querySelector(".all-products-page__filter-options");
      };

      const setAccordionState = function (heading, expanded) {
        const options = resolveHeadingOptions(heading);
        if (!options) return;
        heading.setAttribute("aria-expanded", expanded ? "true" : "false");
        options.hidden = !expanded;
      };

      page.querySelectorAll(headingSelector).forEach(function (heading) {
        if (heading.tagName !== "BUTTON") return;
        const options = resolveHeadingOptions(heading);
        if (!options) return;
        const expanded =
          heading.getAttribute("aria-expanded") === "true" || options.hidden === false;
        setAccordionState(heading, expanded);
      });

      const drawerOverlay = document.createElement("div");
      drawerOverlay.className = "all-products-page__mobile-filter-overlay";
      const allProductsLabels = (window.themeStrings && window.themeStrings.allProducts) || {};
      const mobileFiltersLabel = allProductsLabels.filters || "Filters";
      const mobileCloseFiltersLabel = allProductsLabels.closeFilters || "Close filters";
      drawerOverlay.innerHTML =
        '<div class="all-products-page__mobile-filter-backdrop" data-all-products-mobile-backdrop></div>' +
        '<div class="all-products-page__mobile-filter-panel" role="dialog" aria-modal="true" aria-label="' + mobileFiltersLabel + '">' +
        '<div class="all-products-page__mobile-filter-header">' +
        '<strong class="all-products-page__mobile-filter-header-title">' + mobileFiltersLabel + '</strong>' +
        '<button type="button" class="all-products-page__mobile-filter-close" data-all-products-mobile-close aria-label="' + mobileCloseFiltersLabel + '">' +
        '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        "</button>" +
        "</div>" +
        '<div class="all-products-page__mobile-filter-content" data-all-products-mobile-content></div>' +
        '<button type="button" class="all-products-page__mobile-filter-apply" data-all-products-mobile-apply></button>' +
        "</div>";
      page.appendChild(drawerOverlay);

      const mobileBackdrop = drawerOverlay.querySelector("[data-all-products-mobile-backdrop]");
      const mobileCloseBtn = drawerOverlay.querySelector("[data-all-products-mobile-close]");
      const mobileApplyBtn = drawerOverlay.querySelector("[data-all-products-mobile-apply]");
      const mobileContent = drawerOverlay.querySelector("[data-all-products-mobile-content]");
      const sidebarAnchor = document.createElement("span");
      sidebarAnchor.hidden = true;
      sidebarAnchor.setAttribute("aria-hidden", "true");
      if (sidebar.parentNode) {
        sidebar.parentNode.insertBefore(sidebarAnchor, sidebar);
      }

      const updateMobileApplyText = function () {
        if (!mobileApplyBtn) return;
        const labels = (window.themeStrings && window.themeStrings.allProducts) || {};
        mobileApplyBtn.textContent = mobilePendingChanges ? labels.applyFilters || "Apply filters" : labels.close || "Close";
      };

      const mountSidebarIntoDrawer = function () {
        if (!mobileContent) return;
        if (sidebar.parentNode !== mobileContent) {
          mobileContent.appendChild(sidebar);
        }
      };

      const restoreSidebar = function () {
        if (!sidebarAnchor.parentNode) return;
        if (sidebar.parentNode !== sidebarAnchor.parentNode) {
          sidebarAnchor.parentNode.insertBefore(sidebar, sidebarAnchor.nextSibling);
        }
      };

      const openMobileDrawer = function () {
        if (!isMobileViewport()) return;
        mountSidebarIntoDrawer();
        isMobileDrawerOpen = true;
        sidebar.classList.add("is-open");
        sidebar.style.display = "flex";
        sidebar.style.flexDirection = "column";
        drawerOverlay.classList.add("is-open");
        document.body.classList.add("mobile-nav-open");
        if (mobileOpenBtn) {
          mobileOpenBtn.setAttribute("aria-expanded", "true");
        }
        updateMobileApplyText();
      };

      const closeMobileDrawer = function () {
        isMobileDrawerOpen = false;
        sidebar.classList.remove("is-open");
        sidebar.style.removeProperty("display");
        sidebar.style.removeProperty("flex-direction");
        drawerOverlay.classList.remove("is-open");
        document.body.classList.remove("mobile-nav-open");
        if (mobileOpenBtn) {
          mobileOpenBtn.setAttribute("aria-expanded", "false");
        }
        restoreSidebar();
      };

      if (mobileOpenBtn) {
        mobileOpenBtn.setAttribute("aria-expanded", "false");
        mobileOpenBtn.addEventListener("click", function (event) {
          event.preventDefault();
          if (isMobileDrawerOpen) {
            closeMobileDrawer();
          } else {
            openMobileDrawer();
          }
        });
      }

      if (mobileBackdrop) {
        mobileBackdrop.addEventListener("click", function () {
          closeMobileDrawer();
        });
      }

      if (mobileCloseBtn) {
        mobileCloseBtn.addEventListener("click", function () {
          closeMobileDrawer();
        });
      }

      if (mobileApplyBtn) {
        mobileApplyBtn.addEventListener("click", function () {
          if (mobilePendingChanges) {
            submitForm();
          } else {
            closeMobileDrawer();
          }
        });
      }

      page.addEventListener(
        "click",
        function (event) {
          const heading = event.target.closest(headingSelector);
          if (!heading || !page.contains(heading)) return;
          if (heading.tagName !== "BUTTON") return;
          const options = resolveHeadingOptions(heading);
          if (!options) return;

          event.preventDefault();
          event.stopPropagation();

          const isExpanded = heading.getAttribute("aria-expanded") === "true";
          setAccordionState(heading, !isExpanded);
        },
        true
      );

      page.addEventListener(
        "change",
        function (event) {
          const target = event.target;
          if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) {
            return;
          }

          const isSortField =
            target.matches("#AllProductsSort") ||
            target.matches("[data-all-products-sort]") ||
            target.name === "sort_by";
          const isFilterToggle =
            target.matches('input[type="checkbox"]') || target.matches('input[type="radio"]');
          const isPriceField = target.matches('input[type="number"]');

          if (!isSortField && !isFilterToggle && !isPriceField) return;

          event.stopPropagation();

          if (isSortField) {
            submitForm();
            return;
          }

          if (isMobileViewport() && isMobileDrawerOpen) {
            mobilePendingChanges = true;
            updateMobileApplyText();
            return;
          }

          submitForm();
        },
        true
      );

      page.addEventListener(
        "keydown",
        function (event) {
          if (event.key === "Escape" && isMobileDrawerOpen) {
            closeMobileDrawer();
            return;
          }

          const target = event.target;
          if (!(target instanceof HTMLInputElement)) return;
          if (!target.matches('input[type="number"]')) return;
          if (event.key !== "Enter") return;

          event.preventDefault();
          event.stopPropagation();

          if (isMobileViewport() && isMobileDrawerOpen) {
            mobilePendingChanges = true;
            updateMobileApplyText();
            return;
          }

          submitForm();
        },
        true
      );

      window.addEventListener("resize", function () {
        if (!isMobileViewport() && isMobileDrawerOpen) {
          closeMobileDrawer();
        }
      });
    }
  }

  function initBlogCustom() {
    const pages = document.querySelectorAll("[data-blog-custom]");
    if (!pages.length) return;

    for (const page of pages) {
      const searchInput = page.querySelector("[data-blog-search]");
      const clearBtn = page.querySelector("[data-blog-search-clear]");
      const categoryButtons = Array.from(page.querySelectorAll("[data-blog-category]"));
      const posts = Array.from(page.querySelectorAll("[data-blog-grid] [data-blog-post]"));
      const featuredSection = page.querySelector("[data-blog-featured]");
      const emptyState = page.querySelector("[data-blog-empty]");
      const resetBtn = page.querySelector("[data-blog-reset]");
      const countLabel = page.querySelector("[data-blog-count]");

      if (!posts.length || !searchInput || !categoryButtons.length) continue;

      let activeCategory = "all";
      let searchTerm = "";

      const updateClearButton = function () {
        if (!clearBtn) return;
        clearBtn.hidden = !searchTerm;
      };

      const setActiveCategory = function (nextCategory) {
        activeCategory = nextCategory || "all";
        for (const button of categoryButtons) {
          button.classList.toggle("is-active", button.getAttribute("data-blog-category") === activeCategory);
        }
      };

      const applyFilters = function () {
        let visibleCount = 0;

        for (const post of posts) {
          const categoryAttr = (post.getAttribute("data-category") || "").toLowerCase();
          const categories = categoryAttr
            .split("|")
            .map(function (token) {
              return token.trim();
            })
            .filter(Boolean);

          const searchable = (
            (post.getAttribute("data-search") || "") +
            " " +
            (post.textContent || "")
          ).toLowerCase();

          const matchesCategory = activeCategory === "all" || categories.includes(activeCategory);
          const matchesSearch = !searchTerm || searchable.includes(searchTerm);
          const isVisible = matchesCategory && matchesSearch;

          post.hidden = !isVisible;
          if (isVisible) {
            visibleCount += 1;
          }
        }

        if (featuredSection) {
          featuredSection.hidden = !(activeCategory === "all" && searchTerm.length === 0);
        }

        if (countLabel) {
          if (searchTerm) {
            countLabel.hidden = false;
            countLabel.textContent = fillTemplate(
              getThemeString(
                visibleCount === 1 ? "blog.resultOne" : "blog.resultOther",
                '__COUNT__ results for "__QUERY__"'
              ),
              {
                COUNT: visibleCount,
                QUERY: searchTerm,
              }
            );
          } else {
            countLabel.textContent = "";
            countLabel.hidden = true;
          }
        }

        if (emptyState) {
          emptyState.hidden = visibleCount !== 0;
        }

        updateClearButton();
      };

      for (const button of categoryButtons) {
        button.addEventListener("click", function () {
          const nextCategory = button.getAttribute("data-blog-category") || "all";
          setActiveCategory(nextCategory.toLowerCase());
          applyFilters();
        });
      }

      searchInput.addEventListener("input", function () {
        searchTerm = String(searchInput.value || "").trim().toLowerCase();
        applyFilters();
      });

      if (clearBtn) {
        clearBtn.addEventListener("click", function () {
          searchInput.value = "";
          searchTerm = "";
          applyFilters();
          searchInput.focus();
        });
      }

      if (resetBtn) {
        resetBtn.addEventListener("click", function () {
          searchInput.value = "";
          searchTerm = "";
          setActiveCategory("all");
          applyFilters();
        });
      }

      setActiveCategory("all");
      applyFilters();
    }
  }

  function initContactPage() {
    const pages = document.querySelectorAll("[data-contact-page]");
    if (!pages.length) return;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    for (const page of pages) {
      const form = page.querySelector("[data-contact-form]");
      if (!form) continue;

      const fields = {
        name: form.querySelector('[data-contact-input="name"]'),
        email: form.querySelector('[data-contact-input="email"]'),
        phone: form.querySelector('[data-contact-input="phone"]'),
        topic: form.querySelector('[data-contact-input="topic"]'),
        message: form.querySelector('[data-contact-input="message"]'),
      };

      if (!fields.name || !fields.email || !fields.topic || !fields.message) continue;

      const summaryErrors = form.querySelector("[data-contact-errors]");
      const messageCount = form.querySelector("[data-contact-message-count]");
      const fieldKeys = ["name", "email", "topic", "message"];

      const setFieldError = function (field, message) {
        const errorEl = form.querySelector('[data-contact-error="' + field + '"]');
        if (errorEl) {
          errorEl.textContent = message || "";
          errorEl.hidden = !message;
        }

        const input = fields[field];
        if (input) {
          input.setAttribute("aria-invalid", message ? "true" : "false");
        }
      };

      const clearErrors = function () {
        for (const key of fieldKeys) {
          setFieldError(key, "");
        }
        if (summaryErrors) {
          summaryErrors.hidden = true;
          summaryErrors.textContent = "";
        }
      };

      const updateMessageCounter = function () {
        if (!messageCount || !fields.message) return;
        const len = String(fields.message.value || "").length;
        messageCount.textContent = String(len);
      };

      const validate = function () {
        const errors = {};

        if (!String(fields.name.value || "").trim()) {
          errors.name = "Name is required.";
        }

        const email = String(fields.email.value || "").trim();
        if (!email || !emailRegex.test(email)) {
          errors.email = "Valid email is required.";
        }

        const topic = String(fields.topic.value || "").trim();
        if (!topic || topic === "__placeholder__") {
          errors.topic = "Please select a topic.";
        }

        const message = String(fields.message.value || "").trim();
        if (!message || message.length < 10) {
          errors.message = "Please write at least 10 characters.";
        }

        return errors;
      };

      for (const key of fieldKeys) {
        const input = fields[key];
        if (!input) continue;

        input.addEventListener("input", function () {
          setFieldError(key, "");
          if (summaryErrors && !summaryErrors.hidden) {
            summaryErrors.hidden = true;
            summaryErrors.textContent = "";
          }
          if (key === "message") {
            updateMessageCounter();
          }
        });

        input.addEventListener("change", function () {
          setFieldError(key, "");
          if (summaryErrors && !summaryErrors.hidden) {
            summaryErrors.hidden = true;
            summaryErrors.textContent = "";
          }
          if (key === "message") {
            updateMessageCounter();
          }
        });
      }

      updateMessageCounter();

      form.addEventListener("submit", function (event) {
        clearErrors();
        const errors = validate();
        const keys = Object.keys(errors);
        if (!keys.length) return;

        event.preventDefault();

        for (const key of keys) {
          setFieldError(key, errors[key]);
        }

        if (summaryErrors) {
          summaryErrors.textContent = "Please check the highlighted fields and try again.";
          summaryErrors.hidden = false;
        }

        const firstField = fields[keys[0]];
        if (firstField && typeof firstField.focus === "function") {
          firstField.focus();
        }
      });
    }
  }

  function initCartCustomPage() {
    const pages = document.querySelectorAll("[data-cart-custom-page]");
    if (!pages.length) return;

    const refreshCartPage = async function () {
      try {
        const response = await fetch(localizeInternalUrl("/cart?section_id=main-cart-custom"), {
          headers: { Accept: "text/html" },
        });

        if (!response.ok) {
          return false;
        }

        const html = await response.text();
        const currentPage = document.querySelector("[data-cart-custom-page]");
        if (!currentPage) {
          return false;
        }

        currentPage.outerHTML = html;
        initCartCustomPage();
        return true;
      } catch (error) {
        return false;
      }
    };

    for (const page of pages) {
      if (page.dataset.cartCustomPageReady === "true") continue;
      page.dataset.cartCustomPageReady = "true";

      const deliveryTextEl = page.querySelector(".cart-custom-page__delivery");
      if (deliveryTextEl) {
        deliveryTextEl.textContent = buildDeliveryNoteText();
      }

      let isUpdating = false;

      page.addEventListener("click", function (event) {
        const target = event.target;
        if (!(target instanceof Element) || isUpdating) return;

        const qtyButton = target.closest("[data-cart-page-qty-action]");
        if (qtyButton) {
          event.preventDefault();

          const lineKey = qtyButton.getAttribute("data-cart-line-key") || "";
          const currentQty = Number(qtyButton.getAttribute("data-cart-current-qty") || "1");
          const action = qtyButton.getAttribute("data-cart-page-qty-action");
          const nextQty = action === "increase" ? currentQty + 1 : currentQty - 1;
          const itemRow = qtyButton.closest(".cart-custom-page__item");

          if (!lineKey || nextQty < 1) return;

          isUpdating = true;
          if (itemRow) {
            itemRow.classList.add("is-cart-pending");
          }
          setElementLoading(qtyButton, true);

          fetch(localizeInternalUrl("/cart/change.js"), {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ id: lineKey, quantity: nextQty }),
          })
            .then(function (response) {
              if (!response.ok) {
                throw new Error("Failed to update cart quantity.");
              }

              return refreshCartPage();
            })
            .catch(function () {
              window.location.reload();
            })
            .finally(function () {
              isUpdating = false;
              if (itemRow) {
                itemRow.classList.remove("is-cart-pending");
              }
              setElementLoading(qtyButton, false);
            });

          return;
        }

        const removeButton = target.closest("[data-cart-page-remove]");
        if (!removeButton) return;

        event.preventDefault();

        const lineKey = removeButton.getAttribute("data-cart-line-key") || "";
        const itemRow = removeButton.closest(".cart-custom-page__item");
        if (!lineKey) return;

        isUpdating = true;
        if (itemRow) {
          itemRow.classList.add("is-cart-pending");
        }
        setElementLoading(removeButton, true);

        fetch(localizeInternalUrl("/cart/change.js"), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ id: lineKey, quantity: 0 }),
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error("Failed to remove cart item.");
            }

            return refreshCartPage();
          })
          .catch(function () {
            window.location.reload();
          })
          .finally(function () {
            isUpdating = false;
            if (itemRow) {
              itemRow.classList.remove("is-cart-pending");
            }
            setElementLoading(removeButton, false);
          });
      });

      page.addEventListener("submit", function (event) {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || isUpdating) return;
        if (!form.matches('form[action*="/cart/add"], .cart-custom-page__related-form')) return;

        event.preventDefault();
        event.stopPropagation();

        const submitter = event.submitter instanceof Element ? event.submitter : null;
        const loadingControls = getSubmissionControls(form, { submitter: submitter });

        isUpdating = true;
        form.setAttribute("aria-busy", "true");
        setElementsLoading(loadingControls, true);

        fetch(localizeInternalUrl("/cart/add.js"), {
          method: "POST",
          headers: { Accept: "application/json" },
          body: new FormData(form),
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error("Failed to add item from cart page.");
            }

            return refreshCartPage();
          })
          .catch(function () {
            window.location.reload();
          })
          .finally(function () {
            isUpdating = false;
            form.removeAttribute("aria-busy");
            setElementsLoading(loadingControls, false);
          });
      });
    }
  }

  function init() {
    const heroSections = document.querySelectorAll("[data-home-hero]");
    for (const heroSection of heroSections) {
      initHomeHero(heroSection);
    }

    const pdpMainSections = document.querySelectorAll("[data-pdp-main]");
    for (const pdpMain of pdpMainSections) {
      initPdpMain(pdpMain);
    }

    initSecondaryAtcScroll();
    initHeaderMegaMenu();
    initLegacyShopifyResourceLinks();
    initHeaderSearch();
    initMobileNav();
    initCategoryFilters();
    initAllProductsPage();
    initBlogCustom();
    initContactPage();
    initLocalizedCheckoutForms();
    initCartDrawer();
    initCartCustomPage();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
